import TestimonyModelCommon from 'common/models/testimony';

export default class TestimonyModel extends TestimonyModelCommon {}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    testimony: TestimonyModel;
  }
}
